import React, { useState } from "react";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import PropTypes from "prop-types";

const CollapsibleEvidenceRationale = ({ evidence, rationale }) => {
  const [expanded, setExpanded] = useState(false);

  const hasEvidence = evidence && String(evidence).trim().length > 0;
  const hasRationale = rationale && String(rationale).trim().length > 0;

  if (!hasEvidence && !hasRationale) {
    return null;
  }

  let label = "View ";
  if (hasEvidence && hasRationale) {
    label += "Evidence & Rationale";
  } else if (hasEvidence) {
    label += "Evidence";
  } else {
    label += "Rationale";
  }

  const toggle = () => setExpanded((prev) => !prev);

  // Evidence quotes get secondary visual weight (grey, italic) per the
  // Insights Details color-coded data hierarchy; rationale stays as-is.
  const renderSection = (title, content, isEvidence = false) => (
    <>
      <div className="collapsible-details-section-title">{title}</div>
      <div
        className="collapsible-details-text"
        style={
          isEvidence ? { color: "#666", fontStyle: "italic" } : undefined
        }
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </>
  );

  return (
    <div className="collapsible-details">
      <div className="collapsible-details-header" onClick={toggle}>
        {expanded ? <FiChevronDown /> : <FiChevronRight />} {label}
      </div>
      {expanded && (
        <div className="collapsible-details-content">
          {hasEvidence && renderSection("Evidence", evidence, true)}
          {hasRationale && renderSection("Rationale", rationale)}
        </div>
      )}
    </div>
  );
};

CollapsibleEvidenceRationale.propTypes = {
  evidence: PropTypes.string,
  rationale: PropTypes.string,
};

CollapsibleEvidenceRationale.defaultProps = {
  evidence: "",
  rationale: "",
};

export default CollapsibleEvidenceRationale;
